import React from 'react';
import {ArticleItemSideBarTags} from "./ArticleItemSideBarTags";
import PropTypes from "prop-types";
import {Volunteering} from "../General/Volunteering.jsx";
import {ReportIssue} from "../General/ReportIssue.jsx";
import {BecomeAMember} from "../General/BecomeAMember.jsx";


export const ArticleItemSideBar = ({post, other}) => {

    return (
        <>
            <p style={{marginTop: "25px"}}>&nbsp;</p>
            <ReportIssue />
            <ArticleItemSideBarTags post={post}/>
            <Volunteering />
            <BecomeAMember />   
        </>
    )
}

ArticleItemSideBar.propTypes = {
    post: PropTypes.object,
    other: PropTypes.array
}